import React from 'react';

import block from 'propmods';

import { Loading } from '../Loading';

import './WithSpinner.scss';

const b = block('WithSpinner');

const WithSpinner: React.FC<{ isLoading: boolean; leftOffset?: number }> = ({ isLoading, children, leftOffset }) => {
    return (
        <div {...b()}>
            {children}
            {isLoading && (
                <div {...b('spinner')} style={{ right: leftOffset ? -leftOffset : undefined }}>
                    <Loading size="xs" />
                </div>
            )}
        </div>
    );
};

export default WithSpinner;
